import * as React from "react";
function SvgArrowTip(props) {
  return <svg width="1em" height="1em" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path opacity={0.6} d="M6.5 4l-6-4v8l6-4z" fill="#018AE2" /></svg>;
}
export default SvgArrowTip;